<template>
  <v-menu
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <button
        class="color-button"
        :class="
          layout === 'horizontal'
            ? 'color-button--horizontal layout--margin-top-xs'
            : ''
        "
        type="button"
        v-on="on"
        v-bind="attrs"
      >
        <div class="color-button__swatch" :style="{ backgroundColor: color }">
          <span class="sr-only">{{ color }}</span>
        </div>
        {{ label }}
      </button>
    </template>
    <div class="menu__panel">
      <div class="menu__color-panel">
        <IconPaintBucket
          class="menu__color-icon layout--margin-top-xs"
          style="width: 19px; height: 20px;"
        />
        <input
          id="colorInput"
          type="text"
          class="input-group__input menu__input"
          v-model.lazy="colorInputText"
          @keypress:enter="colorInputText"
        />
        <span
          class="menu__color-swatch layout--margin-top-xxs"
          :style="{ backgroundColor: color }"
        ></span>
      </div>
      <div class="menu__button-panel">
        <button
          type="button"
          @click="selectTab('popular')"
          class="menu__tab"
          :class="{ 'menu__tab--selected': selectedTab === 'popular' }"
        >
          Popular
        </button>
        <button
          type="button"
          @click="selectTab('color picker')"
          class="menu__tab"
          :class="{ 'menu__tab--selected': selectedTab !== 'popular' }"
        >
          Color Picker
        </button>
      </div>
      <color-swatches
        v-on:update:color="selectedColor = $event.color"
        :selected-swatch="color"
        :which-swatch="whichColor"
        v-show="selectedTab === 'popular'"
      />
      <v-color-picker
        class="menu__color-picker"
        v-model.lazy="selectedColor"
        :hide-mode-switch="true"
        dot-size="20"
        mode="hexa"
        v-show="selectedTab !== 'popular'"
        hide-inputs
        width="280"
      ></v-color-picker>
    </div>
  </v-menu>
</template>

<script>
import ColorSwatches from "./ColorSwatches";
import IconPaintBucket from "../../assets/icons/icon-paint-bucket.svg";
import Error from "../../components/Error";
import { debounce } from "lodash";

export default {
  // layout can be null (will be "vertical" by default) or "horizontal"
  props: ["whichColor", "color", "label", "layout"],
  data() {
    return {
      selectedTab: "popular",
      rules: {
        validColor: value => {
          const pattern = /^#([0-9A-F]{3}){1,2}$/i;
          return pattern.test(value);
        },
      },
      lazyColorUpdate: debounce(
        color => {
          this.$emit("color:update", {
            whichSwatch: this.whichColor,
            color: color,
          });
        },
        300,
        { leading: true }
      ),
    };
  },
  components: { ColorSwatches, IconPaintBucket, Error },
  computed: {
    colorInputText: {
      get() {
        return this.color;
      },
      set(newValue) {
        // only emit new color value if it is valid
        if (this.rules.validColor(newValue) === true) {
          this.selectedColor = newValue;
        }
      },
    },
    selectedColor: {
      get() {
        return this.color;
      },
      set(color) {
        if (color.toLowerCase() === this.color) return;
        this.lazyColorUpdate(color);
      },
    },
  },
  methods: {
    selectTab(tabName) {
      this.selectedTab = tabName;
    },
  },
};
</script>

<style lang="scss">
/* style for the color picker dot */
.v-color-picker__dot {
  border: 2px solid #ececec;
}
</style>

<style lang="scss" scoped>
.menu {
  &__input {
    max-width: 150px;
    padding: 0;
    margin: 0 0.7em 0;
    background-color: $white;
  }
  &__color-picker {
    padding: 0.5em;
  }
  &__button-panel {
    border-bottom: 1px solid #e6e5e5;
    padding: 0 2em;
  }
  &__color-panel {
    display: flex;
    background: $darkest-gray;
    padding: 0.5em 2em;
  }
  &__panel {
    background-color: #fff;
  }
  &__color-swatch {
    width: 32px;
    height: 32px;
    display: block;
    border-radius: 100%;
  }
  &__tab {
    padding: 0.5em 0.2em;
    & + & {
      margin-left: 1.5em;
    }
    &--selected {
      border-bottom: 3px solid #000;
    }
  }
  &__color-icon {
    max-width: 19px;
    fill: #666;
  }
}
.color-button {
  text-align: center;
  &__swatch {
    width: 50px;
    height: 50px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0.5em;
    border-radius: 100%;
    border: 1px solid #c0c0c0;
  }
  &--horizontal {
    display: flex;
    align-items: center;
    .color-button__swatch {
      margin-right: 0.5em;
      width: 30px;
      height: 30px;
      margin-bottom: 0;
    }
  }
  &--in-checkbox {
    margin-left: 30px;
  }
}
</style>
